import { Component, computed, inject, signal } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { ToolbarComponent } from '../shared/ui/toolbar/toolbar.component';
import { SidenavComponent } from '../shared/ui/sidenav/sidenav.component';
import { MatIconRegistry } from '@angular/material/icon';
import { AuthStore } from './features/login/store/auth.store';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, map, startWith, tap } from 'rxjs';
import { PATH } from './core/enums';
import { LoadingSpinnerComponent } from '../shared/ui/loading-spinner/loading-spinner.component';

@Component({
  selector: 'app-root',
  imports: [
    RouterModule,
    ToolbarComponent,
    SidenavComponent,
    LoadingSpinnerComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  authStore = inject(AuthStore);
  router = inject(Router);

  readonly isNavigated = signal(false);

  readonly currentRoute = toSignal(
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      tap(() => this.isNavigated.set(true)),
      map((event) => (event as NavigationEnd).urlAfterRedirects),
      startWith(this.router.url),
    ),
  );

  showSidenavLayout = computed(() => {
    if (!this.isNavigated()) return false;
    const isAuthenticated = this.authStore.currentUser();
    const currentUrl = this.currentRoute();

    const externalRoutes = [
      PATH.LOGIN,
      PATH.REGISTER,
      PATH.FORGOT_PASSWORD,
      PATH.RESET_PASSWORD,
    ];

    const isExternalRoute = externalRoutes.some(
      (route) => currentUrl === route,
    );

    return isAuthenticated && !isExternalRoute;
  });

  constructor(private matIconRegistry: MatIconRegistry) {
    this.matIconRegistry.setDefaultFontSetClass('material-symbols-outlined');
  }
}
